var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer_logo"}},[_c('div',[_c('a',{attrs:{"href":_vm.cityWebsite,"target":"__blank"}},[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.cityName}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }